import { render, staticRenderFns } from "./LokasiCabang.vue?vue&type=template&id=062cc2e7&"
import script from "./LokasiCabang.vue?vue&type=script&lang=js&"
export * from "./LokasiCabang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports